import { differenceInMonths, addMonths, differenceInDays } from 'date-fns'

const getDurationObj = (start: Date, end: Date) => {
  const months = differenceInMonths(end, start)
  const remaining = addMonths(start, months)
  const days = differenceInDays(end, remaining)

  return { months, days }
}

export default getDurationObj
